/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { getSignalsListCached } from '../../../../../stores/signals-main/signals/getters';
import moment from 'moment';
import { IconButton, SvgIcon } from '@material-ui/core';
import { Edit as EditIcon } from '../../../../../components/Icons';
import { updateExpirySignalStart } from '../../../../../stores/signals-main/signals/actions';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
}));

const CellExpiry = ({ row = {} }) => {
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;
  const dispatch = useDispatch();

  const expiry = useSelector((state) => {
    const { expiry = undefined } =
      getSignalsListCached(state).find((d) => d._id === _id) || {};

    return expiry;
  });

  const expiryFormatted = expiry
    ? moment(expiry, 'YYYY-MM-DD').format('DD/MM/YYYY')
    : '';

  function onClick() {
    dispatch(updateExpirySignalStart(_id, expiry));
  }

  return (
    <div className={classes.root}>
      {expiryFormatted ? expiryFormatted : 'Add Listen till'}

      <IconButton color="primary" onClick={onClick}>
        <SvgIcon component={EditIcon} fontSize="small" />
      </IconButton>
    </div>
  );
};

export default CellExpiry;
